import axios from "axios";

export async function transferGrades(gradeIdFrom, gradeIdTo) {
    const {data} = await axios.post(`/grade/transfer`,{gradeIdFrom, gradeIdTo});
    return data
}
